// CRA-compatible Plotly wrapper.
// react-plotly.js cannot resolve `plotly.js/dist/plotly` in CRA's strict-ESM
// webpack config, so we use the factory export and supply plotly.js-dist-min.
import Plotly from 'plotly.js-dist-min';
import createPlotlyComponent from 'react-plotly.js/factory';

const Plot = createPlotlyComponent(Plotly);

export default Plot;
